import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="850.538"
      height="740.83"
      data-name="Layer 1"
      viewBox="0 0 850.538 740.83"
    >
      <path
        fill="#f2f2f2"
        d="M766.878 385.54a354.21 354.21 0 01-98.85 245.9q-5.745 6.015-11.8 11.74-9.225 8.775-19.07 16.87a353.934 353.934 0 01-217.58 80.69q-3.975.09-7.98.09c-63.43 0-143.21-33.88-215.61-80.78q-8.985-5.82-17.81-11.91-4.125-2.82-8.21-5.72a730.43 730.43 0 01-79.32-64.8 514.116 514.116 0 01-45.75-48.92c-55.63-68.62-67.9-130.45 11.41-143.16q14.085-2.25 27.34-4.81 19.2-3.69 36.75-7.97 23.64-5.745 44.42-12.46 6.99-2.25 13.66-4.59c65.74-23.09 109.74-53.2 139.69-85.87q7.62-8.295 14.05-16.79a236.055 236.055 0 0017.83-27.12 254.898 254.898 0 0018.41-41.05l.27-.78c23.83-68.74 16.58-132.5 42.87-153.84 112.38-91.23 252.29 38.69 317.96 191.9q4.965 11.58 9.34 23.3 1.965 5.235 3.79 10.49 4.8 13.694 8.71 27.46 1.5 5.25 2.86 10.49c.97 3.77 1.9 7.53 2.76 11.29 6.39 27.53 9.86 54.68 9.86 80.35z"
      ></path>
      <path
        fill="#2f2e41"
        d="M419.578 740.74q-3.975.09-7.98.09c-63.43 0-143.21-33.88-215.61-80.78q-8.985-5.82-17.81-11.91l5.16-31.4L339.548 596l78.4 59.95z"
      ></path>
      <path
        fill="#fff"
        d="M427.098 180.05h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M427.098 218h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6zM427.098 255.95h-22.26a2.601 2.601 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6zM429.658 296.04a2.617 2.617 0 00-2.56-2.14h-22.26a2.601 2.601 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6V296.5a2.313 2.313 0 00-.04-.46zM428.108 332.05a2.634 2.634 0 00-1.01-.2h-22.26a2.595 2.595 0 00-2.6 2.6v22.26a2.588 2.588 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.616 2.616 0 00-1.59-2.4zM473.858 180.05h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M473.858 218h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6zM473.858 255.95h-22.26a2.601 2.601 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6zM473.858 293.9h-22.26a2.593 2.593 0 00-2.46 1.78 2.478 2.478 0 00-.14.82v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M473.858 331.85h-22.26a2.595 2.595 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M520.618 180.05h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6zM520.618 218h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M520.618 255.95h-22.26a2.601 2.601 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M520.618 293.9h-22.26a2.601 2.601 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6zM520.618 331.85h-22.26a2.595 2.595 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6zM567.378 180.05h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#fff"
        d="M567.378 218h-22.26a2.601 2.601 0 00-2.6 2.6v22.27a2.593 2.593 0 002.6 2.59h22.26a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6zM567.378 255.95h-22.26a2.601 2.601 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M567.378 293.9h-22.26a2.601 2.601 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M567.378 331.85h-22.26a2.595 2.595 0 00-2.6 2.6v22.26a2.595 2.595 0 002.6 2.6h22.26a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#fff"
        d="M614.138 180.05h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6zM614.138 218h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6zM614.138 255.95h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M614.138 293.9h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M614.138 331.85h-22.27a2.593 2.593 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#fff"
        d="M660.898 180.05h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6zM660.898 218h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M660.898 255.95h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M660.898 293.9h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#fff"
        d="M660.898 331.85h-22.27a2.593 2.593 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M707.658 180.05h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6zM707.658 218h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M707.658 255.95h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#fff"
        d="M707.658 293.9h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M707.658 331.85h-22.27a2.593 2.593 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6zM754.418 180.05h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6zM754.418 218h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M754.418 255.95h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M754.418 293.9h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6zM754.418 331.85h-22.27a2.593 2.593 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M801.178 180.05h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M801.178 218h-22.27a2.599 2.599 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6zM801.178 255.95h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6zM801.178 293.9h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M801.178 331.85h-22.27a2.593 2.593 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6zM847.938 180.05h-22.27a2.6 2.6 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59v-22.27a2.608 2.608 0 00-2.6-2.6zM847.938 218h-22.27a2.6 2.6 0 00-2.59 2.6v22.27a2.59 2.59 0 002.59 2.59h22.27a2.6 2.6 0 002.6-2.59V220.6a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M847.938 255.95h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.608 2.608 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#e6e6e6"
        d="M847.938 293.9h-22.27a2.6 2.6 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6V296.5a2.608 2.608 0 00-2.6-2.6zM847.938 331.85h-22.27a2.593 2.593 0 00-2.59 2.6v22.26a2.593 2.593 0 002.59 2.6h22.27a2.601 2.601 0 002.6-2.6v-22.26a2.601 2.601 0 00-2.6-2.6z"
      ></path>
      <path
        fill="#2f2e41"
        d="M336.095 660.051L335.475 660.051 336.005 659.981 336.095 660.051z"
      ></path>
      <circle
        cx="282.814"
        cy="176.733"
        r="68.322"
        fill="#ffb6b6"
        data-name="ab6171fa-7d69-4734-b81c-8dff60f9761b"
      ></circle>
      <path
        fill="#2f2e41"
        d="M517.377 206.226s17.87-34.161-21.444-37.267c0 0-33.515-30.402-67.676-5.558 0 0-18.633 0-28.822 21.086 0 0-14.655-5.558-17.876 9.316 0 0-10.723 31.056 0 59.006 10.724 27.95 14.286 31.055 14.286 31.055s-17.621-58.598 25.27-61.704 90.886-29.91 94.46 4.252 8.954 42.577 8.954 42.577 33.95-48.788-7.152-62.763z"
        data-name="bf427902-b9bf-4946-b5d7-5c1c7e04535e"
        transform="translate(-174.731 -79.585)"
      ></path>
      <path
        fill="#cacaca"
        d="M459.548 345.11l-.22 1.16-2.47 13.04-17.07 90.2-1.01 5.31-2.12 11.23-2.9 15.32-6.43 33.95-1.84 9.73-.69 3.65-.24 1.28-1.91 10.07-.58 3.04-4.66 34.53-4.07 30.09 13.62 13.62-8.12 8.12-5.33 30.53.01.07h-217.53q-13.2-8.55-26.02-17.63l1.79-13.4s6.16-23.93 3.57-26.79c-2.58-2.86-8.24-7.97-8.24-7.97l7.13-16.64.99-2.31-1.66-34.43-.04-.83-.55-11.35-.07-1.46-.11-2.19-2.11-43.68-.04-.72-.64-13.24-.6-12.59-.26-5.31-2.57-53.13-1.74-36.08-1.52-31.41 6.11-2.07 65.35-22.21 27.07-35.19 56.34.42 27.58.21 46.02 42.68 10.47 5 .08.04 7.51 3.59 19.04 9.09 20.13 9.62 10.33 4.93z"
      ></path>
      <path
        fill="#ffb6b6"
        d="M269.109 557.55a30.286 30.286 0 01-40.664-22.43l-106.559-15.117 37.043-41.902 95.511 20.78a30.45 30.45 0 0114.669 58.67z"
      ></path>
      <path
        fill="#cacaca"
        d="M221.598 481.37a13.522 13.522 0 00-7.89-4.87l-43.72-9.09-4.49-.93a18.933 18.933 0 01-12.53-9.07 19.16 19.16 0 01-2.45-7.9 18.895 18.895 0 01.89-7.48l15.15-45.65 9.83-29.62a41.792 41.792 0 002.09-11.05 43.349 43.349 0 00-9.07-28.89 42.693 42.693 0 00-49.01-13.64c-.25.09-.51.19-.76.29a42.583 42.583 0 00-25.31 28.41l-10.68 38.85-22.03 80.09a57.766 57.766 0 0048.96 72.68l62.97 7.38 29.14 3.42a13.497 13.497 0 0014.84-10.73 4.895 4.895 0 00.11-.55l.7-4.32 5.93-36.38.06-.37a13.475 13.475 0 00-2.73-10.58z"
      ></path>
      <path
        fill="#ffb6b6"
        d="M336.983 558.717a30.286 30.286 0 0037.094-27.94l103.362-29.994-42.581-36.26-91.627 34.042a30.45 30.45 0 00-6.248 60.152z"
      ></path>
      <path
        fill="#cacaca"
        d="M528.758 433.69l-49.16-113.14a42.819 42.819 0 00-20.27-21.35 43.356 43.356 0 00-8.78-3.2c-.47-.12-.94-.23-1.41-.32a42.132 42.132 0 00-19.48.36 42.814 42.814 0 00-27.34 21.73 1.004 1.004 0 00-.08.14 43.1 43.1 0 00-.37 38.85l.61 1.22 34.74 69.77a18.9 18.9 0 01-10.5 26.19l-2.44.88-43.88 15.85a13.497 13.497 0 00-8.33 16.79l.11.35 12.3 39.36c.06.18.12.36.19.54a7.054 7.054 0 00.4.99 13.482 13.482 0 0015.81 7.53l23.68-6.25 4.83-1.28 61.15-16.15a57.76 57.76 0 0038.22-78.86z"
      ></path>
      <path
        fill="#3f3d56"
        d="M44.898 528.7a514.116 514.116 0 0045.75 48.92h451.97a16.446 16.446 0 0116.42 16.43l.65 114.53a355.43 355.43 0 0077.47-48.53q9.84-8.085 19.07-16.87 6.045-5.73 11.8-11.74a355.629 355.629 0 0068.82-102.74z"
      ></path>
      <path
        fill="#fff"
        d="M668.028 631.44q-5.745 6.015-11.8 11.74h-96.21v-11.74z"
      ></path>
      <path
        fill="#3f3d56"
        d="M458.648 255.95a5.538 5.538 0 00-4.87-2.9h-327.84a5.555 5.555 0 00-5.54 5.55v196.22h338.93V258.6a5.385 5.385 0 00-.68-2.65z"
      ></path>
      <path
        fill="#3f3d56"
        d="M120.101 449.507v24.214a7.644 7.644 0 007.644 7.644h125.097v47.786h-1.662a.993.993 0 00-.993.993v3.324a.993.993 0 00.993.993h77.658a.993.993 0 00.993-.993v-3.324a.993.993 0 00-.993-.993h-1.662v-47.786h125.097a7.644 7.644 0 007.644-7.644v-24.214z"
      ></path>
      <circle cx="285.903" cy="348.704" r="31.306" fill="var(--green-color)"></circle>
      <path
        fill="var(--green-color)"
        d="M365.668 173h-5c0-37.8-37.41-62.57-75.15-62.59a82.382 82.382 0 00-16.35 1.59c-6.06 1.21-12.35 2.66-18.53 4.55-24.37 7.47-46.97 21.91-46.97 56.45a78.591 78.591 0 002.54 19.88l-4.84 1.26a83.876 83.876 0 01-2.7-21.14c0-30.18 12.39-50.91 33.79-63.27 11.25-6.5 24.98-10.69 40.71-12.73a97.13 97.13 0 0119.75-.6c43.4 3.12 72.75 36.4 72.75 76.6z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M373.998 175.77l-1.97-14.56a15.71 15.71 0 00-5-9.56 15.816 15.816 0 00-13.25-4l-3.13.43a6.524 6.524 0 00-4.35 2.53 6.548 6.548 0 00-1.29 4.87l4.55 33.54a6.577 6.577 0 005.3 5.57 6.154 6.154 0 001.22.12 6.499 6.499 0 00.88-.06l3.5-.47a15.791 15.791 0 0010.74-6.43c.27-.38.53-.77.77-1.17a16.748 16.748 0 002.03-10.81z"
      ></path>
      <path
        fill="#fff"
        d="M348.628 148.69a6.432 6.432 0 00-2.33 1.92 6.548 6.548 0 00-1.29 4.87l4.55 33.54a6.577 6.577 0 005.3 5.57z"
      ></path>
      <path
        fill="#3f3d56"
        d="M373.998 175.77l-1.97-14.56a15.71 15.71 0 00-5-9.56l4.53 33.37a6.176 6.176 0 00.41 1.56 16.748 16.748 0 002.03-10.81z"
      ></path>
      <ellipse
        cx="532.218"
        cy="258.909"
        fill="#3f3d56"
        rx="2.5"
        ry="7"
        transform="rotate(-7.725 -144.493 1513.038)"
      ></ellipse>
      <ellipse
        cx="529.218"
        cy="240.909"
        fill="#3f3d56"
        rx="2.5"
        ry="7"
        transform="rotate(-7.725 -147.493 1495.038)"
      ></ellipse>
      <ellipse
        cx="548.218"
        cy="247.909"
        fill="#3f3d56"
        rx="2.5"
        ry="7"
        transform="rotate(-7.725 -128.493 1502.038)"
      ></ellipse>
      <path
        fill="#3f3d56"
        d="M285.518 110.41a82.382 82.382 0 00-16.35 1.59c-6.06 1.21-12.35 2.66-18.53 4.55-9.65-.47-16.75-2.97-18.18-6.82 11.25-6.5 24.98-10.69 40.71-12.73a97.13 97.13 0 0119.75-.6 5.727 5.727 0 012.72 3.82c.47 3.48-3.5 7.18-10.12 10.19z"
      ></path>
      <path
        fill="var(--green-color)"
        d="M221.678 207.7l-7.7-32.01a6.024 6.024 0 00-4.88-4.55 6.733 6.733 0 00-1-.08 6.026 6.026 0 00-1.4.17l-2.98.72a14.904 14.904 0 00-10.99 17.96l3.45 14.36a15.845 15.845 0 005.34 8.62 14.045 14.045 0 001.36.97 14.81 14.81 0 0011.37 1.84l2.97-.72a5.84 5.84 0 002.17-1.01 5.993 5.993 0 002.29-6.27z"
      ></path>
      <ellipse
        cx="378.629"
        cy="274.523"
        fill="#3f3d56"
        rx="2.5"
        ry="7"
        transform="rotate(-13.531 -44.177 971.198)"
      ></ellipse>
      <ellipse
        cx="368.629"
        cy="277.523"
        fill="#3f3d56"
        rx="2.5"
        ry="7"
        transform="rotate(-13.531 -54.177 974.198)"
      ></ellipse>
      <path
        fill="#fff"
        d="M222.168 207.58l-7.7-32.01a6.532 6.532 0 00-5.29-4.92l10.51 43.72a6.511 6.511 0 002.48-6.79z"
      ></path>
      <path
        fill="#3f3d56"
        d="M194.468 183.57a6.476 6.476 0 00-1.17-2.45 14.725 14.725 0 00-.57 8.79l3.45 14.36a15.845 15.845 0 005.34 8.62z"
      ></path>
    </svg>
  );
}

export default Icon;
